import { CredentialResourceID, SecretResourceID } from './system'

const APP = '2M6aBKqTmGINMaLlGSTqqbT9bMv'
const GROUP = '2M6aBUarXl2rBKkfWYMYAdTjwuI'
const ROLE = '2M6aBnUpE0WdSRTRXJXHJX7urpQ'
const USER = '2M6aBec76D6kRQYjQv72ebS8oUt'
const SECRET = SecretResourceID
const ACCOUNT = CredentialResourceID
const ALL = 'ALL'

export type AppResourceTraitTypes = typeof ACCOUNT | typeof APP | typeof GROUP | typeof ROLE | typeof USER | typeof ALL | typeof SECRET
type AppResourceTraitKeys = 'account' | 'app' | 'group' | 'role' | 'user' | 'all' | 'secret'

export const AppResourceTypeTraits: Record<AppResourceTraitKeys, AppResourceTraitTypes> = {
    account: ACCOUNT,
    app: APP,
    group: GROUP,
    role: ROLE,
    user: USER,
    all: ALL,
    secret: SECRET,
}
